module.exports = __webpack_public_path__ + "static/media/best-bike-advice-logo.0098a797.png";